// extracted by mini-css-extract-plugin
module.exports = {"reviewsNum":"_781262","xs":"_9bb4bd","noLink":"_410cca"};